import { Inject, Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-alterar-valor-seguro-modal',
  templateUrl: './alterar-valor-seguro-modal.component.html',
  styleUrls: ['./alterar-valor-seguro-modal.component.scss']
})
export class AlterarValorSeguroModalComponent implements OnInit {
  idSeguro: number;
  valorSeguro: number = 0;

  constructor(
    private dialogRef: MatDialogRef<AlterarValorSeguroModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.valorSeguro = data.valorSeguro;
    this.idSeguro = data.idSeguro;
  }

  ngOnInit(): void {}

  salvar() {
    this.dialogRef.close({ idSeguro: this.idSeguro, valorSeguro: Number(this.valorSeguro) });
  }

  fechar() {
    this.dialogRef.close();
  }

}
